import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { map, take } from 'rxjs/operators';
import { AuthService } from '../../services/auth.service';
import { TENANT_ADMIN_ROLES } from '../../models/enums/user-role.enum';

export const tenantAdminGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.currentProfile$.pipe(
    take(1),
    map((profile) => {
      if (profile && TENANT_ADMIN_ROLES.includes(profile.role)) {
        return true;
      }

      router.navigate(['/']);
      return false;
    }),
  );
};
